import {isNonEmptyString} from "@tomeravni/easybizy-js-common/common";

const PHONE_VALIDATION_REGEXP = /^[0-9\-\+\b]+$/;
const EMAIL_VALIDATION_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


export const validateAdaptPhoneNumber = (currentValue) => {
    if (currentValue === '' || PHONE_VALIDATION_REGEXP.test(currentValue)) {
        let modifiedValue = currentValue.replace(/\-/gi, '');
        const length = modifiedValue.length;
        let desiredLength = 10;
        let value;
        if (modifiedValue.charAt(0) !== '+') {
            if (length > 2) {
                // Three digits
                if (modifiedValue.charAt(0) !== '0' || ['5', '7'].indexOf(modifiedValue.charAt(1)) > -1) {
                    if (length > 3) {
                        modifiedValue = modifiedValue.slice(0, 3) + '-' + modifiedValue.slice(3)
                    }
                } else { // 2 digits
                    desiredLength = 9;
                    modifiedValue = modifiedValue.slice(0, 2) + '-' + modifiedValue.slice(2)
                }
            }

            value = modifiedValue.slice(0, 11);
        } else {
            value = modifiedValue.slice(0, 13);
            desiredLength = 12;
        }

        return {
            isValid: value.length === desiredLength + 1,
            adaptedValue: value
        }
    }

    return {
        isValid: false,
        adaptedValue: currentValue
    }
}

export const validateAdaptEmail = (required = false) => (currentValue) => {
    return {
        adaptedValue: currentValue,
        isValid: (!required && !isNonEmptyString(currentValue)) || EMAIL_VALIDATION_REGEXP.test(currentValue)
    }
}

export const validateAdaptIdentifyNumber = (currentValue) => {
    let adaptedCurrent = String(currentValue).trim();
    if (adaptedCurrent.length > 9 || !isNonEmptyString(adaptedCurrent)) {
        return {
            isValid: false,
            adaptedValue: currentValue
        }
    }

    adaptedCurrent = adaptedCurrent.length < 9 ? ("00000000" + adaptedCurrent).slice(-9) : adaptedCurrent;
    const isValid = Array.from(adaptedCurrent, Number).reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
    }) % 10 === 0;

    return {
        isValid,
        adaptedValue: currentValue
    }
}


export const validateAdaptMinLength = (minLength) => (currentValue) => {
    return {
        isValid: currentValue.length >= minLength,
        adaptedValue: currentValue
    }
}
